import {createSelector} from 'reselect';
import {AppState} from '../..';
import {CardApplicationStatus} from '../../../types/enums/cardApplicationStatus';

export const loginResponseSelector = () =>
  createSelector(
    (state: AppState) => state.login.loginResponse,
    (item) => item,
  );

export const loginSelector = () =>
  createSelector(
    (state: AppState) => state.login.login,
    (item) => item,
  );

export const sendCodeResponseSelector = () =>
  createSelector(
    (state: AppState) => state.login.sendCodeResponse,
    (item) => item,
  );

export const esiaLinkSelector = (state: AppState) => state.login.esiaLink;

export const esiaCodeSelector = (state: AppState) => state.login.esiaCode;

export const esiaUserNotAcceptSelector = (state: AppState) => state.login.esiaUserNotAccept;

export const esiaUserHasNoCardsSelector = (state: AppState) => state.login.esiaUserHasNoCards;

export const esiaRegistrationInfoSelector = (state: AppState) => state.login.esiaRegistrationInfo;

export const cardApplicationIsExpired = (state: AppState) =>
  state.login.esiaRegistrationInfo?.cardApplicationStatusId === CardApplicationStatus.Declined;
